module.exports = __webpack_public_path__ + "img/52114141_L.8a82c713.png";